//eslint-disable-next-line import/no-unresolved
import 'vite/modulepreload-polyfill';

import '../js/leaflet.js';
import '../scss/app.css';
import '../scss/main.css';
import App from './App.vue';
import {redirectIfRootDomain} from '@/shared/helpers/urlHelper';

import VtDataTable from './admin/components/tables/core/VtDataTable.vue';
import VtGenericFilter from './admin/components/tables/core/VtGenericFilter.vue';
import VtPerPageSelector from './admin/components/tables/core/VtPerPageSelector.vue';
import navigationGuard from './router/navigationGuard.js';
import cyDirective from './shared/directives/v-cy.js';
import translation from './shared/mixins/translation';
import store from './store';
import {autoAnimatePlugin} from '@formkit/auto-animate/vue';
import router from './router/router';
import {sentryPlugin} from '@/plugins/sentryPlugin';
import VCalendar, {DatePicker} from 'v-calendar';
import {ServerTable} from 'v-tables-3';
import {createApp} from 'vue';
import VueFinalModal from 'vue-final-modal';
import FloatingVue from 'floating-vue';
import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';
import useDrilldown from 'highcharts/modules/drilldown';
import {globalOptions} from './shared/mixins/chartsHelper';
import {createPinia} from 'pinia';
import PrimeVue from 'primevue/config';
import PrimeVueGlobal from './shared/primevue/global.js';
import ToastService from 'primevue/toastservice';
import {trackMatomoPageView} from './shared/matomoTracking';
import {tanStackPlugin} from '@/plugins/tanStackPlugin';
import {hybridAppPlugin} from '@/plugins/hybridAppPlugin';

if (__IS_HYBRID_APP__) {
    import('./hybridApp').then(({init}) => {
        init();
    });
}

redirectIfRootDomain();

import.meta.glob(['../images/**']);

const app = createApp(App);

useDrilldown(Highcharts);
Highcharts.setOptions(globalOptions);

const floatingVueOptions = {
    themes: {
        tooltip: {
            distance: 10,
            delay: {
                show: 150,
                hide: 0,
            },
        },
        'default-popup': {
            $extend: 'dropdown',
            $resetCss: true,
            distance: 8,
        },
        'information-dropdown': {
            $extend: 'dropdown',
            $resetCss: true,
            distance: 8,
        },
        'resource-tooltip': {
            $extend: 'tooltip',
            $resetCss: true,
            distance: 8,
        },
        'rich-tooltip': {
            $extend: 'dropdown',
            $resetCss: true,
            distance: 12,
        },
    },
};

const pinia = createPinia();
app.use(pinia)
    .use(router)
    .use(sentryPlugin)
    .use(store)
    .use(VueFinalModal())
    .use(ServerTable, {}, 'tailwind', {
        dataTable: VtDataTable,
        genericFilter: VtGenericFilter,
        perPageSelector: VtPerPageSelector,
    })
    .use(VCalendar)
    .use(autoAnimatePlugin)
    .use('VDatePicker', DatePicker)
    .use(HighchartsVue, {Highcharts, tagName: 'customChart'})
    .use(PrimeVue, {
        unstyled: true,
        pt: {global: PrimeVueGlobal},
    })
    .use(ToastService)
    .use(FloatingVue, floatingVueOptions)
    .use(tanStackPlugin)
    .use(hybridAppPlugin)
    .directive('cy', cyDirective)
    .mixin(translation)
    .mount('#app');

router.beforeEach(navigationGuard);
router.afterEach(to => {
    trackMatomoPageView(to.fullPath);
});
